var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Megaphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.868,
    height: 22.405,
    viewBox: "0 0 22.868 22.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-megaphone",
    d: "M17.448,3l-.858,1.1L5.433,8.149V13.3l2.1.763-.243.687a.989.989,0,0,0,.6,1.264l1.869.662a.992.992,0,0,0,1.266-.605l.231-.655,5.327,1.931.858,1.1h1.716V3Zm0,2.618V15.829l-.273-.1L7.149,12.095V9.353L17.174,5.717ZM2,8.149V13.3H3.716V8.149Z",
    transform: "translate(-3.336 8.229) rotate(-34)",
    fill: "#827564"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Megaphone);
export default __webpack_public_path__ + "static/media/icons8-megaphone.3b6050dc2c55428fe93ca8d0993acbd5.svg";
export { ForwardRef as ReactComponent };